import { type CSSProperties } from 'react';
import tw, { styled } from 'twin.macro';
import { breakpoints } from '@/constants/breakpoints';

export const StyledPicture = styled.picture<{
  style: CSSProperties;
}>`
  ${tw`block`}
  ${tw`overflow-hidden`}
  ${tw`relative`}
  ${tw`w-full`}
  ${tw`max-h-[500px] lg:max-h-full`}

  /** responsive aspect ratio placeholder */
  &:before {
    ${tw`block`}
    content: '';
    padding-top: calc(var(--mobile-ratio-height) / var(--mobile-ratio-width) * 100%);

    @media (min-width: ${breakpoints.TABLET}px) {
      padding-top: calc(var(--tablet-ratio-height) / var(--tablet-ratio-width) * 100%);
    }

    @media (min-width: ${breakpoints.DESKTOP}px) {
      padding-top: calc(var(--desktop-ratio-height) / var(--desktop-ratio-width) * 100%);
    }
  }
`;

export const StyledImage = styled.img<{
  fit: 'contain' | 'cover';
}>`
  ${tw`max-h-[500px] w-full lg:max-h-full`}
  ${tw`absolute`}
  ${tw`inset-0`}
  object-fit: ${({ fit }) => fit};
`;
